import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Table
} from 'reactstrap';

/** The translated-page fields this modal reads (the list row plus its populated source page). */
type SourceData = {
  _id?: string;
  global_title?: string;
  page_template?: { name?: string };
  parentPage?: {
    global_title?: string;
    page_configuration: { path?: string; type?: string };
    publish_statement?: string;
    site: { country_code?: string; domain?: string; language_code?: string };
    updatedAt?: string;
  };
};

type SourceDataModalProps = {
  isOpen: boolean;
  toggle: () => void;
  sourceData?: SourceData | null;
};

const SourceDataModal = ({ isOpen, toggle, sourceData }: SourceDataModalProps) => {
  

  const data = sourceData;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <i className="fas fa-info-circle me-2 text-primary"></i>
        Source Data Information
      </ModalHeader>

      <ModalBody>
        {/* Site Information Card */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex align-items-center mb-3">
              <i className="fas fa-globe text-primary me-2" style={{ fontSize: '1.5rem' }}></i>
              <h5 className="mb-0">Site Information</h5>
            </div>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">SITE NAME</strong>
                  <span className="h6">{sourceData?.parentPage?.site.domain}</span>

                </div>
              </Col>
             
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">COUNTRY CODE</strong>
                  <Badge color="primary" pill className="px-3">
                    {sourceData?.parentPage?.site.country_code}
                  </Badge>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">LANGUAGE</strong>
                  <Badge color="info" pill className="px-3">
                    
                    {sourceData?.parentPage?.site.language_code}

                  </Badge>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Page Information Card */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex align-items-center mb-3">
              <i className="fas fa-file-alt text-success me-2" style={{ fontSize: '1.5rem' }}></i>
              <h5 className="mb-0">Page Information</h5>
            </div>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <strong className="text-muted d-block small">PAGE Ttitle</strong>
                  <span className="h6"> {sourceData?.parentPage?.global_title}</span>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">PAGE TYPE</strong>
                  <Badge color="secondary" className="px-3">
                    {sourceData?.parentPage?.page_configuration.type}
                    
                  </Badge>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">TEMPLATE</strong>
                  <span className="text-sm">{sourceData?.page_template?.name}
</span>

                  
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">Publish Status</strong>
                  <Badge color="success" className="px-3">
                    <i className="fas fa-check-circle me-1"></i>
                    {sourceData?.parentPage?.publish_statement}     
                                 </Badge>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <strong className="text-muted d-block small">PAGE URL</strong>
                  <code className="text-primary">
                      {sourceData?.parentPage?.site.domain}/{sourceData?.parentPage?.page_configuration.path}
                  </code>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* SEO & Meta Information */}
        
        
        {/* <Card className="mb-4">
          <CardBody>
            <div className="d-flex align-items-center mb-3">
              <i className="fas fa-search text-warning me-2" style={{ fontSize: '1.5rem' }}></i>
              <h5 className="mb-0">SEO & Meta Information</h5>
            </div>
            <div className="mb-3">
              <strong className="text-muted d-block small">META TITLE</strong>
              <p className="mb-2">{data.metaTitle}</p>
            </div>
            <div className="mb-3">
              <strong className="text-muted d-block small">META DESCRIPTION</strong>
              <p className="text-muted">{data.metaDescription}</p>
            </div>
            <Row>
              <Col md="4">
                <div className="text-center">
                  <div className="h3 text-warning mb-0">{data.seoScore}/100</div>
                  <small className="text-muted">SEO Score</small>
                </div>
              </Col>
              <Col md="4">
                <div className="text-center">
                  <small className="text-muted">Page Views</small>
                </div>
              </Col>
              <Col md="4">
                <div className="text-center">
                  <div className="h3 text-success mb-0">{data.loadTime}</div>
                  <small className="text-muted">Load Time</small>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card> */}

        {/* Additional Details */}
        <Card>
          <CardBody>
            <div className="d-flex align-items-center mb-3">
              <i className="fas fa-cogs text-dark me-2" style={{ fontSize: '1.5rem' }}></i>
              <h5 className="mb-0">Additional Details</h5>
            </div>
            <Table size="sm" className="mb-0">
              <tbody>
               
                
                <tr>
                  <td className="border-0 py-1"><strong>Last Modified:</strong></td>
                  <td className="border-0 py-1">{sourceData?.parentPage?.updatedAt}</td>
                  
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <i className="fas fa-times me-2"></i>
          Close
        </Button>
       
      </ModalFooter>
    </Modal>
  );
};

export default SourceDataModal;